import { PaginatedVisitors } from 'clients/VisitorClient';
import {
    VISITORS_REQUESTED,
    VISITORS_SUCCESS,
    VISITORS_FAILED,
    ADD_VISITOR_REQUESTED,
    ADD_VISITOR_SUCCESS,
    ADD_VISITOR_FAILED,
    EDIT_VISITOR_REQUESTED,
    EDIT_VISITOR_SUCCESS,
    EDIT_VISITOR_FAILED,
    DELETE_VISITOR_REQUESTED,
    DELETE_VISITOR_SUCCESS,
    DELETE_VISITOR_FAILED,
    UPLOAD_VISITOR_CSV_REQUESTED,
    UPLOAD_VISITOR_CSV_SUCCESS,
    UPLOAD_VISITOR_CSV_FAILED,
    PROGRESS_UPLOAD_VISITOR_CSV_REQUESTED,
    PROGRESS_UPLOAD_VISITOR_CSV_SUCCESS,
    PROGRESS_UPLOAD_VISITOR_CSV_FAILED,
} from './constants';
import { Action } from '../useReducerWithMiddleware';

export type CSVProgress = { value: number; max: number };
export type VisitorsState = {
    loading: boolean;
    errorMessage: string;
    visitors: PaginatedVisitors | null;
    successMessage: string;
    uploadCsvProgress: CSVProgress;
};

export const initialVisitorsState: VisitorsState = {
    loading: false,
    errorMessage: '',
    successMessage: '',
    visitors: null,
    uploadCsvProgress: { value: 0, max: 0 },
};

export default function visitorsReducer(state: VisitorsState = initialVisitorsState, action: Action): VisitorsState {
    switch (action.type) {
        case VISITORS_REQUESTED:
        case ADD_VISITOR_REQUESTED:
        case EDIT_VISITOR_REQUESTED:
        case DELETE_VISITOR_REQUESTED:
        case UPLOAD_VISITOR_CSV_REQUESTED:
        case PROGRESS_UPLOAD_VISITOR_CSV_REQUESTED:
            return {
                ...state,
                errorMessage: '',
                successMessage: '',
                loading: true,
            };
        case VISITORS_SUCCESS:
            return {
                ...state,
                loading: false,
                visitors: (action.payload as { visitors: PaginatedVisitors }).visitors,
            };
        case VISITORS_FAILED:
        case ADD_VISITOR_FAILED:
        case EDIT_VISITOR_FAILED:
        case DELETE_VISITOR_FAILED:
        case UPLOAD_VISITOR_CSV_FAILED:
        case PROGRESS_UPLOAD_VISITOR_CSV_FAILED:
            return {
                ...state,
                errorMessage: (action.payload as { message: string }).message,
                loading: false,
                uploadCsvProgress: { value: 0, max: 0 },
            };
        case PROGRESS_UPLOAD_VISITOR_CSV_SUCCESS:
            return {
                ...state,
                uploadCsvProgress: (action.payload as { uploadCsvProgress: CSVProgress }).uploadCsvProgress,
            };
        case ADD_VISITOR_SUCCESS:
        case EDIT_VISITOR_SUCCESS:
        case DELETE_VISITOR_SUCCESS:
            return {
                ...state,
                loading: false,
                successMessage: (action.payload as { message: string }).message,
                visitors: (action.payload as { visitors: PaginatedVisitors }).visitors,
            };
        case UPLOAD_VISITOR_CSV_SUCCESS:
            return {
                ...state,
                successMessage: (action.payload as { message: string }).message,
            };
        default:
            return state || initialVisitorsState;
    }
}
